export const statuses = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  NOT_ACCEPTABLE: 406,
  INTERNAL_SERVER_ERROR: 500,
};

export const ENDPOINTS = {
  login: "auth/login",
  customerSearch: "/Customer/Detail",
  customerSearchBefore: "/Customer/newSearch",
  updatePaymentStatus: "/Customer/UpdatePaymentStatus",
  getPlatform: "/Feature/GetPlatform",
  getMarket: "/Feature/GetMarket",
  getPerspective: "/Feature/GetPerspective",
  getVendor: "/Feature/GetVendor",
  getResearch: "/Feature/GetResearch",
  getForeignIndices: "/Feature/GetForeignIndices",
  getAlgorithmAndServer: "/Feature/GetAlgorithmAndServer",
  getAlgorithmDetail: "/Feature/GetAlgorithmDetail",
  getResearchDetail: "/Feature/GetResearchDetail",
  getAllPackages: "/Purchase/List",
  getRecommendedPackageList: "/RecommendationPackage/List",
  getRecommendedPackageAllList: "/RecommendationPackage/AllList",
  getPackageDetail: "/Purchase/Detail",
  getBranchListForFilter: "/Filter/GetBranchListForFilter",
  getDraftPackageDetail: "/Purchase/DraftDetail",
  getRecommendedPackageDetail: "/RecommendationPackage/Detail",
  recommendedPackageOrderIncrease: "/RecommendationPackage/OrderIncrease",
  recommendedPackageOrderDecrease: "/RecommendationPackage/OrderDecrease",
  fillFilter: "/Filter/GetFilterAttribute",
  getApps: "/Feature/GetApplication",
  getAllResearch: "/Feature/GetAllResearch",
  getProfAlgoApps: "/Feature/GetApplicationByGroupId",
  updatePackage: "/Purchase/Update",
  updateRecommendationPackage: "/RecommendationPackage/Update",
  createPackage: "/Purchase/Create",
  createRecommendationPackage: "/RecommendationPackage/Create",
  createAlgorithm: "/Purchase/AlgorithmCreate",
  createResearch: "/Purchase/ResearchCreate",
  confirm: "/Purchase/Confirm",
  getPackageSummary: "/Purchase/Detail",
  getAppTabs: "/Feature/GetApplicationType",
  getProfAlgoTab: "/Feature/GetApplicationGroup",
  getHistory: "/Purchase/History",
  getHistoryList: "/History/List",
  getFundAndCommissionRates: "/Purchase/FundAndCommissionRates",
  cancelPackage: "/Purchase/Cancelled",
  cancelRecommendedPackage: "/RecommendationPackage/Cancelled",
  getInvoiceList: "/Purchase/InvoiceList",
  postRepresentationPerson: "/History/Representatives",
  getRepresentativeReport: "/Report/RepresentativeReport",
  getRepresExport: "/Report/RepresentativeReportExportExcel",
  getPurchaseActivatedStatus: "/Purchase/Activated",
  getRecommendationSummary: "/RecommendationPackage/Detail",
  getPurchaseChangeStartDate: "/Purchase/PurchaseChangeStartDate",
  getAllApplicationTypes: "/ApplicationType/list",
  createApplicationType: "/ApplicationType/Create",
  updateApplicationType: "/ApplicationType/Update",
  deleteApplicationType: "/ApplicationType/Delete",
  getAllPlatforms: "/Platform/list",
  createPlatform: "/Platform/Create",
  updatePlatform: "/Platform/Update",
  deletePlatform: "/Platform/Delete",
  getAllPerspectives: "/Perspective/list",
  createPerspective: "/Perspective/Create",
  updatePerspective: "/Perspective/Update",
  deletePerspective: "/Perspective/Delete",
  getAllAKDs: "/Vendor/list",
  createAKD: "/Vendor/Create",
  updateAKD: "/Vendor/Update",
  deleteAKD: "/Vendor/Delete",
  getAllMarkets: "/Market/list",
  createMarket: "/Market/Create",
  updateMarket: "/Market/Update",
  deleteMarket: "/Market/Delete",
  getAllAlgorithmAndServers: "/AlgorithmAndServer/list",
  createAlgorithmAndServer: "/AlgorithmAndServer/Create",
  updateAlgorithmAndServer: "/AlgorithmAndServer/Update",
  deleteAlgorithmAndServer: "/AlgorithmAndServer/Delete",
  deActivateAlgorithmAndServer: "/AlgorithmAndServer/Deactivate",
  activateAlgorithmAndServer: "/AlgorithmAndServer/Activate",
  algorithmAndServerOrderDecrease: "AlgorithmAndServer/OrderDecrease",
  algorithmAndServerOrderIncrease: "AlgorithmAndServer/OrderIncrease",
  featureSettings: "/FeatureSettings/list",
  siteSettings: "SiteSettings/GetCostMultiplexer",
  updateMultiplexer: "SiteSettings/UpdateCostMultiplexer",
  createFeatureSetting: "FeatureSettings/Create",
  updateFeatureSetting: "FeatureSettings/Update",
  deleteFeatureSetting: "FeatureSettings/Delete",
  deActivateFeatureSetting: "FeatureSettings/Deactivate",
  activateFeatureSetting: "FeatureSettings/Activate",
  copyFeatureSetting: "FeatureSettings/Copy",
  copyAlgorithms: "AlgorithmAndServer/Copy",
  copyResearchs: "Research/Copy",
  copyForeign: "ForeignIndice/Copy",
  researchList: "Research/list",
  researchCreate: "Research/Create",
  researchUpdate: "Research/Update",
  researchDelete: "Research/delete",
  deActivateResearch: "Research/Deactivate",
  activateResearch: "Research/Activate",
  foreignList: "ForeignIndice/list",
  foreignCreate: "ForeignIndice/Create",
  foreignUpdate: "ForeignIndice/Update",
  foreignDelete: "ForeignIndice/Delete",
  applicationTypeOrderIncrease: "ApplicationType/OrderIncrease",
  applicationTypeOrderDecrease: "ApplicationType/OrderDecrease",
  platformOrderDecrease: "Platform/OrderDecrease",
  platformOrderIncrease: "Platform/OrderIncrease",
  perspectiveOrderDecrease: "Perspective/OrderDecrease",
  perspectiveOrderIncrease: "Perspective/OrderIncrease",
  akdOrderDecrease: "Vendor/OrderDecrease",
  akdOrderIncrease: "Vendor/OrderIncrease",
  marketOrderDecrease: "Market/OrderDecrease",
  marketOrderIncrease: "Market/OrderIncrease",
  researchOrderDecrease: "Research/OrderDecrease",
  researchOrderIncrease: "Research/OrderIncrease",
  manuelReportExport: "Report/VeriDagitimReportExportExcel",
  vdsReportExport: "Report/VdsReportExportExcel",
  algorithmPurchaseExportExcel: "Report/AlgorithmPurchaseExportExcel",
  reportList: "Report/List",
  getMember: "SiteSettings/GetMember",
  checkMonthClosingProcessStatusURL:
    "MonthClosing/CheckMonthClosingProcessStatus",
  monthClosingExportUnderOverallCustomersURL:
    "MonthClosing/ExportUnderOverallCustomers",
  monthClosingSendOverallNotificationMailURL:
    "MonthClosing/SendOverallNotificationMail",
  monthClosingOverallURL: "MonthClosing/CancelByOverall",
  monthClosingListURL: "MonthClosing/List",
  monthClosingMailTemplates: "MonthClosing/MailTemplates",
  monthClosingGetCurrentOverallLimit: "SiteSettings/GetOverallLimit",
  monthClosingDepartmentList: "Branch/BranchList",
  monthClosingSelectedDepartment: "Branch/SelectMonthClosingBranchs",
  monthClosingDateTime: "MonthClosing/GetBesDataRecordDate",
  updateOverallLimit: "SiteSettings/UpdateOverallLimit",
  userRoleGetUsersList: "Customer/InternalUsers",
  userRoleAddNewUser: "Customer/AddNewInternalUser",
  userRoleRemoveInternalUser: "Customer/RemoveInternalUser",
  customerMoveStartDate: "Purchase/MovePurchaseStartDate",
  checkForPurchaseUpgrade: "Purchase/CheckForPurchaseUpgrade",
  screenPrices: "Feature/GetAllFeaturePrice",
  featureScreenPrices: "Feature/GetFeaturesForScreenPrices",
};

export const CurrencySymbol = {
  tl: "₺",
  dolar: "$",
  euro: "€",
};
